// extracted by mini-css-extract-plugin
export default {"file-info":"IspBjgND6e7LoDvUgDyz","tags":"wF8MGDRzRg4YorKMLoRl"};